import React, { useEffect, useState } from "react";
import contact1 from "../assets/contact1.1.png";
// import phone from "../assets/phone.png";
// import fax from "../assets/fax.png";
import email from "../assets/email.png";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiResponse } from "@/types/Api";
import { ApiRoutes } from "@/config/routes/ApiRoutes";
import { ValidationErrors } from "@/types/ValidationError";
import { ContactType } from "./ContactType";
import GenericApi from "@/api/genericApi";
import CustomLogger from "@/utils/CustomLogger";
import { ContactSubmitQueryKey } from "@/config/constants/QueryKeys";

const Contact: React.FC = () => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  const queryClient = useQueryClient();

  // const submitButton = useMutation<
  //   ApiResponse<ContactType>,
  //   ApiError<ValidationErrors>,
  //   ContactType
  // >({
  //   mutationFn: (data) =>
  //     GenericApi.post<ContactType>(ApiRoutes.CONTACT_SUBMIT, data),
  //   onSuccess: async ({ data }) => {
  //     CustomLogger.log(data);
  //     await queryClient.invalidateQueries({
  //       queryKey: [ContactSubmitQueryKey],
  //     });
  //     setIsSubmitted(true);
  //   },
  //   onError: async ({ error }) => {
  //     CustomLogger.error(error);
  //     setIsSubmitted(false);
  //   },
  // });

  const [formData, setFormData] = useState<ContactType>({
    name: "",
    email: "",
    phone: "",
    found_by: null,
  });

  const submitButton = useMutation<
    ApiResponse<ContactType>,
    ApiError<ValidationErrors>,
    ContactType
  >({
    mutationFn: (data) =>
      GenericApi.post<ContactType>(ApiRoutes.CONTACT_SUBMIT, data),
    onSuccess: async ({ data }) => {
      CustomLogger.log(data);
      await queryClient.invalidateQueries({
        queryKey: [ContactSubmitQueryKey],
      });

      setStatus("submitted");
    },
    onError: async ({ error }) => {
      CustomLogger.error(error);
      setStatus("idle"); 
    },
  });

  const [status, setStatus] = useState<"idle" | "submitting" | "submitted">(
    "idle"
  );

  const handleSubmit = () => {
    setStatus("submitting"); // înainte de a face mutate
    submitButton.mutate(formData);
  };

  return (
    <div className="contact__1 gap-36 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0 max-[899px]:gap-0 max-[899px]:overflow-x-hidden">
      <div className="contact__1__container">
        <div className="contact__1__container__name mb-[3rem] pt-[5rem]">
          Contact us
        </div>
        <div className="contact__1__container__form">
          <div className="contact__1__container__form__title">Get in Touch</div>
          <div className="contact__1__container__form__text">
            Please do not hesitate to contact us! We are here to get your
            business to the next level.
          </div>
          <form>
            <div className="contact__1__container__form__inputs">
              <input
                className="contact__1__container__form__inputs__fields"
                type="text"
                id="name"
                name="name"
                placeholder="Name *"
                required
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
              <input
                className="contact__1__container__form__inputs__fields"
                type="text"
                id="email"
                name="email"
                placeholder="Email *"
                required
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
              />
              <input
                className="contact__1__container__form__inputs__fields"
                type="text"
                id="phone"
                name="phone"
                placeholder="Phone Number *"
                required
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
              />
              <input
                className="contact__1__container__form__inputs__fields"
                type="text"
                id="how"
                name="how"
                placeholder="How did you find us?"
                required
                onChange={(e) =>
                  setFormData({ ...formData, found_by: e.target.value })
                }
              />
            </div>
          </form>
          <div
            className="contact__1__container__form__button cursor-pointer"
            onClick={handleSubmit}
          >
            {status === "submitting"
              ? "Submitting..."
              : status === "submitted"
              ? "Submitted"
              : "Submit"}
          </div>
          <div className="contact__1__container__form__data">
            {/* <div className="flex-r">
              <div>
                <img src={phone} alt="photo" />
              </div>
              <div className="flex flex-col">
                <div className="contact__1__container__form__data__text">
                  PHONE
                </div>
                <div className="contact__1__container__form__data__text">
                  123456789
                </div>
              </div>
            </div> */}
            {/* <div className="flex-r">
              <div>
                <img src={fax} alt="photo" />
              </div>
              <div className="flex flex-col">
                <div className="contact__1__container__form__data__text">
                  FAX
                </div>
                <div className="contact__1__container__form__data__text">
                  123456789
                </div>
              </div>
            </div> */}
            <div className="flex-r">
              <div>
                <img src={email} alt="photo" />
              </div>
              <div className="flex flex-col">
                <div className="contact__1__container__form__data__text">
                  EMAIL
                </div>
                <div className="contact__1__container__form__data__text">
                  hello@leonext.exchange
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isMobile ? (
        <img
          className="border-[11px] rounded-[35px] border-[#111B31] bg-[#111B31] h-[25rem] me-[-15rem] mt-[-6rem]"
          src={contact1}
          alt="photo"
        />
      ) : (
        <img
          className="border-[21px] rounded-[35px] border-[#111B31] bg-[#111B31] mt-[10rem]"
          src={contact1}
          alt="photo"
        />
      )}
      <div className="contact__greenBar"></div>
    </div>
  );
};

export default Contact;
